import type { ConfigObjectMetadata } from '../types/config.types'

const mockMetadataMap: Record<string, ConfigObjectMetadata> = {}

export function getMockMetadata(nodeId: string): ConfigObjectMetadata | null {
  return mockMetadataMap[nodeId] ?? null
}
